var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBrand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 40,
  fill: "none",
  viewBox: "0 0 55 55"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#brand_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#brand_svg__b)",
  d: "M42.496.125a4.97 4.97 0 0 0-2.522.706 5 5 0 0 0-1.821 1.896L27.052 24.62l15.01 29.554h12.066V.125z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#brand_svg__c)",
  d: "M0 54.125h12.066L27.1 24.57 16 2.678A4.85 4.85 0 0 0 14.207.75a4.8 4.8 0 0 0-2.527-.7H.048"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#brand_svg__d)",
  d: "M12.018 54.125h30.044L27.028 24.376z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "brand_svg__b",
  x1: 53.088,
  x2: 53.088,
  y1: 17.881,
  y2: 53.151,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#14D7CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#02A8D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "brand_svg__c",
  x1: 9.653,
  x2: 9.653,
  y1: -0.362,
  y2: 53.152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9D500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "orange"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "brand_svg__d",
  x1: 27.052,
  x2: 27.052,
  y1: 29.071,
  y2: 58.503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F16C8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#E65494"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C63894"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "brand_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .125h237v54H0z"
})))));
export default SvgBrand;